<template>
  <section class="hr-hero" aria-label="Главный баннер">
    <div class="hr-container">
      <div class="hr-hero__card">
        <div class="hr-hero__media" aria-hidden="true">
          <img :src="data.image" alt="" />
        </div>
        <div class="hr-hero__shade" aria-hidden="true"></div>

        <div class="hr-hero__content">
          <p class="hr-hero__eyebrow">
            <span class="hr-hero__eyebrow-mark" aria-hidden="true"></span>
            {{ data.eyebrow }}
          </p>

          <h1 class="hr-hero__title">
            <span class="hr-hero__title-lead">{{ data.titleLine1 }}</span>
            <span class="hr-hero__title-brand">{{ data.titleBrand }}</span>
          </h1>

          <p class="hr-hero__desc">{{ data.description }}</p>

          <div class="hr-hero__actions">
            <router-link
              v-for="action in data.actions"
              :key="action.label"
              class="hr-btn hr-hero__btn"
              :class="action.primary ? 'hr-btn--primary' : 'hr-btn--ghost'"
              :to="action.to"
            >
              <HrIcon :name="action.icon" :image="action.iconImage" />
              <span>{{ action.label }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HrIcon from './HrIcon.vue'

export default {
  name: 'HrHero',
  components: { HrIcon },
  props: {
    data: { type: Object, required: true },
  },
}
</script>
